export default __webpack_public_path__ + "static/media/not_suggested.fa0f7c80.svg";